export const Views = Object.freeze({
  List: 1,
  Table: 2,
});
